export default {
	label: 'Staatus',
	implemented: 'Rakendatud',
	conditionallyImplemented: 'Tingimuslikult rakendatud',
	partiallyImplemented: 'Osaliselt rakendatud',
	notImplemented: 'Rakendamata',
	needsAttention: 'Vajab ülevaatamist',
	willNotImplement: 'Ei rakendata',
	willNotApply: 'Ei kohaldata',
	renewedMeasure: 'Uuendatud meede',
	hover: {
		conditionallyImplemented: 'Meede on tingimuslikult rakendatud - üks või mitu reeglitest on staatuses "Ei rakendata"/"Ei kohaldata".',
	},
}
